<template>
  <div class="md-layout">
    <md-toolbar
      id="customer_profile_header"
      md-elevation="0"
      class="md-transparent"
    >
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <div>
            <div class="md-headline">{{ customerName }}</div>
            <div class="md-body-1">
              <span v-show="customer.email"
                ><md-icon class="md-primary">alternate_email</md-icon>
                <a :href="`mailto:${customer.email}`">
                  {{ customer.email }}</a
                ></span
              >
              <span v-show="customer.tel_num"
                ><md-icon class="md-primary">phone</md-icon>
                {{ customer.tel_num }}</span
              >
              <span v-show="customer.cell_num"
                ><md-icon class="md-primary">phone_iphone</md-icon>
                {{ customer.cell_num }}</span
              >
            </div>
          </div>
        </div>
        <div class="md-toolbar-section-end">
          <div class="delete-customer" v-show="allowDelete">
            <md-button class="md-danger md-sm" @click="deleteCustomer"
              ><md-icon>delete</md-icon> Delete Customer</md-button
            >
          </div>
          <div v-if="customer.manager">
            <manager-dropdown
              v-model="customer.manager.id"
              @input="managerSelected"
            />
          </div>
        </div>
      </div>
      <div class="md-toolbar-row">
        <md-button
          id="add-tag"
          class="md-icon-button md-dense md-primary md-round"
          @click="showTagDialog = true"
        >
          <md-icon>add</md-icon>
          <md-tooltip md-direction="top">Add a Tag</md-tooltip>
        </md-button>
        <div id="customer-tags" class="md-chips md-success">
          <md-chip
            v-on:md-delete="removeTag(tag)"
            v-for="tag in customer.tags"
            :key="tag.id"
            md-deletable
            >{{ tag.name }}</md-chip
          >
        </div>
      </div>
    </md-toolbar>
    <div class="md-layout-item md-size-40">
      <customer-edit :customer="customer"></customer-edit>
    </div>
    <div class="md-layout-item md-size-60" v-if="hasLoaded">
      <customer-tabs :customer="customer"></customer-tabs>
    </div>
    <customer-tags
      :availableTags="availableTags"
      :showTagDialog="showTagDialog"
      @tagSelected="tagSelected"
      @close="showTagDialog = false"
    ></customer-tags>
  </div>
</template>

<script>
import customerApi from "@/services/api/customer";
import ManagerDropdown from "@/components/Handi/Users/ManagerDropdown.vue";

import CustomerTags from "./CustomerTags";
import CustomerEdit from "./CustomerEdit";
import CustomerTabs from "./CustomerTabs";
import Swal from "sweetalert2";
import customer from "../../services/api/customer";

import _filter from "lodash/filter";
import _differenceWith from "lodash/differenceWith";

export default {
  props: ["id"],

  data() {
    return {
      customer: {
        title: "",
        first_name: "",
        last_name: "",
        tags: []
      },
      tagList: [],
      showTagDialog: false,
      hasLoaded: false
    };
  },

  components: {
    CustomerTags,
    CustomerEdit,
    CustomerTabs,
    ManagerDropdown
  },

  methods: {
    getCustomer(id) {
      customerApi
        .getCustomer(id)
        .then(response => {
          this.customer = response.data;
          this.hasLoaded = true;
        })
        .catch(e => {});
    },

    deleteCustomer() {
      Swal.fire({
        title: "Are you absolutely sure?",
        text: `This will delete the Customer!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          customerApi.deleteCustomer(this.customer).then(response => {
            this.$notify({
              timeout: 2500,
              message: "The Customer has been deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
            this.$router.push({ name: "Customer Management" });
          });
        }
      });
    },

    managerSelected(managerId) {
      customerApi
        .updateCustomer({
          setmanager: true,
          id: this.customer.id,
          manager: {
            id: managerId
          }
        })
        .then(response => {
          this.$notify({
            timeout: 2500,
            message: "The Manager has been assigned.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(error => {});
    },

    getTags() {
      customerApi.getCustomerTags().then(resp => {
        this.tagList = resp.data.tags;
      });
    },

    addTag(tag) {
      customerApi.addCustomerTag(this.customer, tag.id).then(() => {
        this.customer.tags(tag);
      });
    },

    removeTag(tag) {
      customerApi.removeCustomerTag(this.customer, tag.id).then(() => {
        this.customer.tags = _filter(this.customer.tags, function(t) {
          return t.id !== tag.id;
        });
      });
    },

    tagSelected(tag) {
      customerApi.addCustomerTag(this.customer, tag.id).then(() => {
        this.customer.tags.push(tag);
      });
    }
  },

  computed: {
    customerName: function() {
      return [
        this.customer.title,
        this.customer.first_name,
        this.customer.last_name
      ].join(" ");
    },

    allowDelete: function() {
      return (
        this.customer.bookings_count == 0 && this.customer.enquiries_count == 0
      );
    },

    availableTags: function() {
      return _differenceWith(
        this.tagList,
        this.customer.tags,
        (arrVal, othVal) => arrVal.id === othVal.id
      );
    }
  },

  watch: {
    "$route.params.id": function(id) {
      this.getCustomer(id);
    }
  },

  created() {
    this.getCustomer(this.id);
    this.getTags();
  }
};
</script>

<style lang="scss" scoped>
#add-tag {
  min-width: 30px;
  width: 30px;
  height: 30px;
  margin-top: 12px;
  margin-right: 10px;
}

#customer_profile_header {
  margin-bottom: 1rem;

  .md-headline {
    margin-bottom: 0.5rem;
  }

  span {
    display: inline-block;
    margin-right: 1rem;
  }
  .md-toolbar-section-end {
    align-self: flex-end;

    .delete-customer {
      padding: 3px 7px 5px 7px;
      margin-right: 1em;
    }
  }
}
</style>
